export default __webpack_public_path__ + "static/media/05_Learn-a-new-song-Share.8dc78fdc.jpg";